(function() {
    'use strict';

    angular
        .module('atheer.doc', [

        ]);
})();
